import axios from "axios";
import { REACT_APP_API_URL } from "../api/global";

export const fetchLeaderboardData =
  (token, filter, subFilter, childFilter) => async (dispatch) => {
    dispatch({ type: "FETCH_LEADERBOARD_REQUEST" });
    const sub_filter = subFilter ? subFilter : "";
    const child_filter = childFilter ? childFilter : "";

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/getLeaderboard?filter=${filter}&sub_filter=${sub_filter}&child_filter=${child_filter}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      dispatch({ type: "FETCH_LEADERBOARD_SUCCESS", payload: response.data });
    } catch (error) {
      dispatch({ type: "FETCH_LEADERBOARD_FAILURE", payload: error.message });
    }
  };
